import React__default from "react";
import { Button } from "../button/button.mjs";
import debounce from "debounce";
import "tabbable";
import { useResponsiveProps } from "../helpers/helper/hooks/use-responsive-props.mjs";
import { useLabels } from "../helpers/label-provider/use-labels.mjs";
const ScrollToTopButtonResponsive = (props) => {
  const { responsive, ...rest } = props;
  const responsiveProps = useResponsiveProps({ responsive });
  return /* @__PURE__ */ React__default.createElement(ScrollToTopButtonInner, { ...rest, ...responsiveProps });
};
const ScrollToTopButtonInner = (props) => {
  var _a, _b;
  const { button, bottom = "1rem", right = "1rem", scrollPosition = 100 } = props;
  const labels = useLabels();
  const scrollTopLabel = ((_a = props.button) == null ? void 0 : _a.text) || labels.get("scrollTop");
  const scrollTopIcon = ((_b = props.button) == null ? void 0 : _b.icon) || "#arrow-up";
  const [isVisible, setIsVisible] = React__default.useState(false);
  React__default.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > scrollPosition) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    const scrollHandler = debounce(handleScroll, 100);
    window.addEventListener("scroll", scrollHandler);
    return () => {
      window.removeEventListener("scroll", scrollHandler);
      scrollHandler.clear();
    };
  }, [scrollPosition]);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: "scroll-to-top-button",
      style: {
        bottom,
        right,
        display: isVisible ? "block" : "none"
      }
    },
    /* @__PURE__ */ React__default.createElement(Button, { ...button, text: scrollTopLabel, icon: scrollTopIcon, onClick: scrollToTop })
  );
};
const ScrollToTopButton = (props) => {
  const { responsive, ...rest } = props;
  return responsive ? /* @__PURE__ */ React__default.createElement(ScrollToTopButtonResponsive, { ...rest, responsive }) : /* @__PURE__ */ React__default.createElement(ScrollToTopButtonInner, { ...rest });
};
export {
  ScrollToTopButton
};
